import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import auth from '../reducers/auth';
import clans from '../reducers/clans';
import log from '../reducers/log';
import metrics from '../reducers/metrics';
import payments from '../reducers/payments';
import place from '../reducers/place';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default () => {
  const store = createStore(
    combineReducers({
      auth,
      clans,
      log,
      metrics,
      payments,
      place
    }),
    composeEnhancers(applyMiddleware(thunk))
  );

  return store;
};
